import moment, { Moment } from 'moment-timezone';

import { DeviceStatus, DeviceStatusFromLastSeenEnum, StatusColors } from '../../interfaces';

const DEVICE_OFFLINE_THRESHOLD = moment.duration(5, 'minutes');

const getStatusColorFromDeviceStatus = (deviceStatus: DeviceStatusFromLastSeenEnum): StatusColors => {
  switch (deviceStatus) {
    case DeviceStatusFromLastSeenEnum.ONLINE:
      return StatusColors.GREEN;
    case DeviceStatusFromLastSeenEnum.OFFLINE:
      return StatusColors.GRAY;
  }
};

const getLastSeen = (deviceStatus: DeviceStatus): Moment => {
  const deviceKeys = ['gps', 'lte', 'wireless', 'able', 'camera'] as (keyof DeviceStatus)[];
  let lastSeen = moment(0);
  deviceKeys.forEach((key) => {
    const devicePart = deviceStatus[key] as any;
    const timeParsedViaMoment = moment(devicePart?.time);
    if (timeParsedViaMoment.isValid() && timeParsedViaMoment.isAfter(lastSeen) && timeParsedViaMoment.isBefore(moment())) {
      lastSeen = timeParsedViaMoment;
    }
  });
  // handle case of missing time field everywhere
  if (lastSeen.isSame(moment(0))) {
    return null;
  }
  return lastSeen;
};

const getDeviceStatusFromLastSeen = (lastSeen: Moment): DeviceStatusFromLastSeenEnum => {
  if (moment().subtract(DEVICE_OFFLINE_THRESHOLD).isAfter(lastSeen)) {
    return DeviceStatusFromLastSeenEnum.OFFLINE;
  }
  return DeviceStatusFromLastSeenEnum.ONLINE;
};

export const enhanceDeviceStatus = (deviceStatus: DeviceStatus): DeviceStatus => {
  const last_seen = getLastSeen(deviceStatus);
  const last_seen_status = getDeviceStatusFromLastSeen(last_seen);
  const last_seen_status_color = getStatusColorFromDeviceStatus(last_seen_status);
  return {
    ...deviceStatus,
    last_seen,
    last_seen_status,
    last_seen_status_color,
    // vehicle_name: deviceStatus.vehicle_name || 'N/A',
  };
};
